import React, { useEffect } from 'react'
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
  clearAll,
  onOnboardUser,
  setErrorMessage,
  setLoading
} from "../../../config/redux/slice/authSlice";
import { postRequest } from '../../../helpers/request';
import { appApi } from '../../../utils/endpoints/appApi';
import { appUrls } from '../../../utils/urls/appUrls';
import { AuthAlert, PasswordComponent, Spinner } from '../../components';
import AuthFormWrapper from '../../layout/AuthFormWrapper';

export default function Registration() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {register, handleSubmit, watch, getValues, setValue, formState: {errors}, reset} = useForm({mode: 'onTouched'})
  const {
        loading,
        errorMsg,
    } = useSelector((state) => state.authData)

    console.log(errorMsg)

    const passwordValue = watch('password')

    useEffect(()=>{
      dispatch(clearAll({}))
    }, [])

    const onSubmit = async (data) => {
        dispatch(clearAll({}))
        const res = await postRequest(
            "",
            `${appApi.register}`,
            data,
            dispatch,
            setLoading,
            "",
            setErrorMessage
        )
        if(res !== undefined && res.status < 400){
          dispatch(onOnboardUser({email: data.email}))
          navigate(appUrls.emailLinkSuccess)
        }
    }

    const closeAlert = () => {
        dispatch(setErrorMessage({message: null}))
    }

  return (
    <AuthFormWrapper sub_text='Create your account' onHandleSubmit={handleSubmit(onSubmit)}>
      {errorMsg && <AuthAlert onClick={closeAlert} alertStyles={{width: '95%', margin: '0 auto'}} status='error'>
        {errorMsg}
      </AuthAlert>}
      <div className="form-group col-md-12 mb-3">
        <label className='text-capitalize mb-2'>I am registering as a:</label>
        <div>
          <div className="form-check form-check-inline">
            <input 
              className="form-check-input" id="user_role_transferee" type="radio" value="Transferee"
              {...register("user_role", {
            required: {
              value: true,
              message: '*this field is required'
            }
          })}  
            />
            <label className="form-check-label" htmlFor="user_role_transferee">Transferee</label>
          </div>
          <div className="form-check form-check-inline">
            <input 
              className="form-check-input" id="user_role_bank" type="radio" value="Bank"
              {...register("user_role", {
            required: {
              value: true,
              message: '*this field is required'
            }
          })} 
            />
            <label className="form-check-label" htmlFor="user_role_bank">Bank Representative</label>
          </div>
        </div>

        {
          errors?.user_role?.message &&
          <div className="text-danger small mt-1">
            {errors?.user_role?.message}
          </div>
        }
      </div> 
      <div className="form-group col-md-12 mb-4">
        <label htmlFor='first_name'>First Name</label>
        <input 
          type="text" 
          className="form-control input-lg" 
          id="first_name"
          {...register("first_name", {
            required: {
              value: true,
              message: '*this field is required'
            }
          })
          } 
        />
        {
          errors?.first_name?.message &&
          <div className="text-danger small mt-1">
            {errors?.first_name?.message}
          </div>
        }
      </div> 
      <div className="form-group col-md-12 mb-4">
        <label htmlFor='last_name'>Last Name</label>
        <input 
          type="text" 
          className="form-control input-lg" 
          id="last_name"
          {...register("last_name", {
            required: {
              value: true,
              message: '*this field is required'
            }
          })
          } 
        />
        {
          errors?.last_name?.message &&
          <div className="text-danger small mt-1">
            {errors?.last_name?.message}
          </div>
        }
      </div>                
      <div className="form-group col-md-12 mb-4">
        <label htmlFor='email'>Email</label>
        <input 
          type="email" 
          className="form-control input-lg" 
          id="email" 
          aria-describedby="emailHelp"
          {...register("email", {
            required: {
              value: true,
              message: '*this field is required'
            },
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: '*invalid email pattern'
            }
          })
          }
        />
        {
          errors?.email?.message &&
          <div className="text-danger small mt-1">
            {errors?.email?.message}
          </div>
        }
      </div>
      <PasswordComponent
        fieldName={'password'}
        error_msg={errors.password?.message}
        label={'Password'}
        isReq={true}
        register={register}
        patternRules={'password'}
        hasHelperText={true}
      />
      <PasswordComponent
        fieldName={'password_confirmation'}
        error_msg={errors.password_confirmation?.message}
        label={'Confirm Password'}
        isReq={true}
        register={register}
        patternRules={'password'}
        isSameAs={passwordValue}
      />
      {/* <div className="form-group col-md-12 ">
        <label htmlFor='password'>Password</label>
        <input 
          type="password" 
          className="form-control input-lg" 
          id="password"
          {...register("password", {
            required: {
              value: true,
              message: '*this field is required'
            },
            pattern: {
              value: 'password',
              message: '*invalid password pattern'
            }
          })
        }
        />
        {
          errors?.password?.message ?
          <div className="text-danger small mt-1">
            {errors?.password?.message}
          </div> :
          <span style={{fontSize: '0.815rem'}} className="mt-2 d-block">Note: Password must be at least 8 character long and include at least 1 Upper case, 1 Digit</span>
        }
      </div>
      <div className="form-group col-md-12 ">
        <label htmlFor='password_confirmation'>Confirm Password</label>
        <input 
          type="password" 
          className="form-control input-lg" 
          id="password_confirmation"
          {...register("password_confirmation", {
            required: {
              value: true,
              message: '*this field is required'
            },
            validate: value => value === getValues('password') || "Passwords does not match"
          })
        }
        />
        {
          errors?.password_confirmation?.message &&
          <div className="text-danger small mt-1">
            {errors?.password_confirmation?.message}
          </div>
        }
      </div> */}
      <div className="col-md-12">

        <div>
          {loading ? 
            <Spinner/> :
            <button type="submit" className="btn btn-primary mb-4">Register</button>
          }
        </div>

        <p>Have an account already?&nbsp;
          <Link className="text-blue" to={appUrls.login}>Login Here</Link>
          {/* <a className="text-blue" href="sign-up.html">Login Here</a> */}
        </p>
      </div>
    </AuthFormWrapper>
  )
}
